<template>
  <div class="answer-content">
    <div class="inner-header">
      <span class="title">答题卡</span>
    </div>
    <div class="answer-progress">
      <p class="score">当前成绩：<span>{{ totalCount }}</span></p>
      <ul class="status-list">
        <li v-for="item in statusList" :key="item.name">
          <i :style="{ backgroundColor: item.color }"></i>{{ item.name }}
        </li>
      </ul>
    </div>
    <div class="scroll-box">
      <div class="select-content" v-for="(t, i) in questionList" :key="i">
        <span class="select-box">—</span>
        <p class="question-type">{{ formateType(t.typeId, t.questionType) }}</p>
        <ul class="question-list">
          <li class="item"
              v-for="(_t, _i) in t.indexList"
              :class="{
                'is-correct': _t.isCorrect && t.typeId !== 11,
                'is-error': !_t.isCorrect && t.typeId !== 11,
                'no-score': t.typeId === 11
              }"
              :key="_i" @click="changeQuestion(_t.id)">{{ _t.index }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { formateQuesType } from '@/utils/common'
export default {
  props: {
    questionList: {
      type: Array,
      default () {
        return []
      }
    },
    totalCount: {
      type: Number,
      default: 0
    },
    currentQuestionId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      statusList: [
        {
          name: '正确',
          color: '#00C882'
        }, {
          name: '错误',
          color: '#FF4E4E'
        }, {
          name: '主观已批',
          color: '#FF9743'
        }, {
          name: '主观未批',
          color: '#C5CDDA'
        }
      ]
    }
  },
  methods: {
    changeQuestion (id) {
      this.$emit('changeQuestion', id)
    },
    formateType(id, questionType = 0) {
      return formateQuesType(id, questionType)
    }
  }
}
</script>

<style lang="scss" scoped>
  .answer-content {
    width: 360px;
    height: 100%;
    background-color: #fff;
    box-shadow:0 0 20px 0 rgba(0, 0, 0, .1);
    border-radius: 8px 8px 0 0;
    padding: 20px;
    position: relative;
    margin-right: 20px;
    overflow: hidden;
    .scroll-box {
      position: relative;
      height: calc(100% - 190px);
      overflow: scroll;
      padding-bottom: 82px;
      &::-webkit-scrollbar {
        width: 10px;
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background: #666;
      }
      &::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        background: #f7f7f7;
      }
    }
  }
  .inner-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 20px;
    border-bottom: 1px solid #f2f7ff;
    margin-bottom: 20px;
    .title {
      font-size: 24px;
      color: #333;
      line-height: 32px;
      font-weight: 500;
    }
  }
  .answer-progress {
    width: 100%;
    background-color: #FAFAFA;
    border-radius: 4px;
    padding: 20px;
    margin-bottom: 20px;
    .score {
      font-size: 18px;
      color: #333;
      line-height: 35px;
      span {
        color: #FF4E4E;
        font-size: 24px;
      }
    }
    .status-list {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      color: #666;
      margin-top: 20px;
      i {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 2px;
        margin-right: 5px;
        vertical-align: -3px;
      }
    }
  }
  .select-content {
    padding-left: 25px;
    width: 260px;
    position: relative;
    .select-box {
      position: absolute;
      top: 5px;
      left: 0;
      width: 16px;
      height: 16px;
      border-radius: 2px;
      background-color: #fff;
      font-size: 14px;
      color: rgba(0, 0, 0, .65);
      border: 1px solid rgba(0, 0, 0, .15);
      line-height: 12px;
      text-align: center;
      cursor: pointer;
      font-weight: 300;
      &:hover {
        border: 1px solid #397EFD;
        color: #397EFD;
      }
    }
    .question-type {
      font-size: 18px;
      color: #333;
      line-height: 25px;
      margin-bottom: 20px;
    }
    .question-list {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      &.hidden {
        height: 0;
      }
      .item {
        width: 32px;
        height: 32px;
        border-radius: 2px;
        background-color: #fff;
        border:1px solid #DBE7F5;
        font-size: 14px;
        line-height: 30px;
        color: #666;
        text-align: center;
        margin-right: 15px;
        margin-bottom: 15px;
        cursor: pointer;
        &:nth-of-type(5n) {
          margin-right: 0;
        }
        &:hover {
          border:1px solid #397EFD;
        }
        &.is-correct {
          background-color: #00C882;
          color: #fff;
          border: none;
        }
        &.is-error {
          background-color: #FF4E4E;
          color: #fff;
          border: none;
        }
        &.no-score {
          background-color: #C5CDDA;
          color: #fff;
          border: none;
        }
        &.has-score {
          background-color: #FF9743;
          color: #fff;
          border: none;
        }
      }
    }
  }
</style>
